<div *ngIf="cartData$ | async as cartData; else loading">
  <div *ngFor="let product of cartData.entries">
    <vs-quote-cart-product
      [reviewFlag]="'true'"
      [product]="product"
      [reasonForQuotes]='reasonForQuote'
      (refreshList)="refreshList($event)"
    ></vs-quote-cart-product>
  </div>
</div>
<ng-template #loading>
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
</ng-template>
